import React from 'react';
import { useTranslation } from 'react-i18next';
import CatalogManager from './CatalogManager';
import { Supplier } from '../../types/catalogs';

const SuppliersPage: React.FC = () => {
  const { t } = useTranslation();
  const columns = [
    { key: 'nombre', label: t('name') },
    { key: 'contacto', label: t('contact') },
    { key: 'telefono', label: t('phone') },
    { key: 'email', label: t('email') },
  ];

  const formFields = [
    { name: 'nombre', label: t('name'), type: 'text' as const, required: true },
    { name: 'contacto', label: t('contactPerson'), type: 'text' as const },
    { name: 'telefono', label: t('phone'), type: 'text' as const },
    { name: 'email', label: t('email'), type: 'email' as const },
    { name: 'activo', label: t('active'), type: 'checkbox' as const },
  ];

  const createEmptyItem = () => ({
    nombre: '',
    contacto: '',
    telefono: '',
    email: '',
    activo: true,
  });

  const validateItem = (item: any) => {
    if (!item.nombre?.trim()) return t('requiredName');
    if (item.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(item.email)) {
      return t('invalidEmail');
    }
    return null;
  };

  return (
    <CatalogManager<Supplier>
      title={t('catalogSuppliers')}
      apiEndpoint="suppliers"
      columns={columns}
      formFields={formFields}
      getItemId={(item) => item.id}
      getItemAttributes={(item) => item.attributes}
      createEmptyItem={createEmptyItem}
      validateItem={validateItem}
    />
  );
};

export default SuppliersPage;
